export enum VEHICLE_TYPE_OPTIONS {
  EV = 'EV',
  NON_EV = 'Non-EV',
}

export enum VEHICLE_TYPE {
  EV = 1,
  NON_EV = 2,
}

export const vehicleTypeOptions = [VEHICLE_TYPE_OPTIONS.EV, VEHICLE_TYPE_OPTIONS.NON_EV]

export const vehicleTypeOptionsMap = {
  [VEHICLE_TYPE_OPTIONS.EV]: VEHICLE_TYPE.EV,
  [VEHICLE_TYPE_OPTIONS.EV.toLowerCase()]: VEHICLE_TYPE.EV,
  [VEHICLE_TYPE_OPTIONS.NON_EV]: VEHICLE_TYPE.NON_EV,
  [VEHICLE_TYPE_OPTIONS.NON_EV.toLowerCase()]: VEHICLE_TYPE.NON_EV,
}

export const vehicleTypeMap = {
  [VEHICLE_TYPE.EV]: VEHICLE_TYPE_OPTIONS.EV,
  [VEHICLE_TYPE.NON_EV]: VEHICLE_TYPE_OPTIONS.NON_EV,
}
